module.exports = __webpack_public_path__ + "static/img/product_images_36_h5_zh.565e1d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_36_h5_zh.png
// module id = vPPh
// module chunks = 34